module.exports = __webpack_public_path__ + "img/copia.e536e1f0.jpg";